<div class="merge-account">
    @let user = user$ | async;
    @let accountDetails = accountDetails$ | async;
    @let mergeAccountStatus = mergeAccountStatus$ | async;

    <h1 mat-dialog-title [innerHTML]="'account.mergeAccount.title' | translate"></h1>

    <mat-stepper #stepper linear="true" mat-dialog-content orientation="vertical" [disableRipple]="true">
        <mat-step [editable]="mergeAccountStatus !== 'processing'" [label]="'account.mergeAccount.text1' | translate" [stepControl]="form">
            <app-form-group [formGroup]="form">
                <mat-form-field class="--is-100">
                    <mat-label [innerHTML]="'account.mergeAccount.accountIdPlaceholder' | translate"></mat-label>
                    <input
                        formControlName="newCodeAccount"
                        matInput
                        type="text"
                        [placeholder]="'account.mergeAccount.accountIdPlaceholder' | translate"
                    />
                </mat-form-field>

                @if (mergeAccountError$ | async; as error) {
                    <app-banner color="danger" icon="cancel">
                        <div [innerHTML]="error | translate"></div>
                    </app-banner>
                }
            </app-form-group>
        </mat-step>

        <mat-step [label]="'account.mergeAccount.text2' | translate">
            @let mergeAccount = mergeAccount$ | async;

            <div class="merge-account__summary">
                <div class="merge-account__summary__before">
                    <div class="merge-account__summary__card">
                        <p class="merge-account__summary__card__title" [innerHTML]="'account.mergeAccount.anonymous' | translate"></p>
                        @if ((mergeAccount?.identifiers?.length || 0) === 1) {
                            <p
                                [innerHTML]="
                                    mergeAccount?.identifiers && mergeAccount?.identifiers?.length
                                        ? (mergeAccount?.identifiers)![0].code
                                        : '-'
                                "
                            ></p>
                        }
                        @if ((mergeAccount?.identifiers?.length || 0) > 1) {
                            <p
                                [innerHTML]="
                                    ('account.mergeAccount.identifiers1' | translate) +
                                    mergeAccount?.identifiers?.length +
                                    ('account.mergeAccount.identifiers2' | translate)
                                "
                                [matTooltip]="(mergeIdentifiersTooltip$ | async)!"
                            ></p>
                        }
                    </div>

                    <div class="merge-account__summary__card">
                        <p class="merge-account__summary__card__title2" [innerHTML]="'account.mergeAccount.pointBalance' | translate"></p>
                        <p class="merge-account__summary__card__points" [innerHTML]="mergeAccount?.accountBalance?.points"></p>
                    </div>
                </div>
                <mat-icon>arrow_forward</mat-icon>
                <div class="merge-account__summary__after">
                    <div class="merge-account__summary__card">
                        <p
                            class="merge-account__summary__card__title"
                            [innerHTML]="user?.user?.emailAddress || ('account.mergeAccount.anonymous' | translate)"
                        ></p>
                        @if ((accountDetails?.identifiers?.length || 0) === 1) {
                            <p
                                [innerHTML]="
                                    accountDetails?.identifiers && accountDetails?.identifiers?.length
                                        ? (accountDetails?.identifiers)![0].code
                                        : '-'
                                "
                            ></p>
                        }
                        @if ((accountDetails?.identifiers?.length || 0) > 1) {
                            <p
                                [innerHTML]="
                                    ('account.mergeAccount.identifiers1' | translate) +
                                    accountDetails?.identifiers?.length +
                                    ('account.mergeAccount.identifiers2' | translate)
                                "
                                [matTooltip]="(identifiersTooltip$ | async)!"
                            ></p>
                        }
                    </div>
                    <div class="merge-account__summary__card">
                        <p class="merge-account__summary__card__title2" [innerHTML]="'account.mergeAccount.pointBalance' | translate"></p>
                        <p class="merge-account__summary__card__points" [innerHTML]="accountDetails?.accountBalance?.points"></p>
                    </div>
                    <div class="merge-account__summary__card">
                        <p class="merge-account__summary__card__title2" [innerHTML]="'account.mergeAccount.afterMerge' | translate"></p>
                        <p
                            class="merge-account__summary__card__points"
                            [innerHTML]="(mergeAccount?.accountBalance?.points || 0) + (accountDetails?.accountBalance?.points || 0)"
                        ></p>
                    </div>
                </div>
            </div>

            @if (mergeAccountStatus === "processing") {
                <app-banner color="primary" icon="info">
                    <div [innerHTML]="'account.mergeAccount.processing' | translate"></div>
                </app-banner>
            }
        </mat-step>
    </mat-stepper>

    <mat-dialog-actions align="end">
        <app-button [text]="'buttons.cancel' | translate" (click)="dialog.close()"></app-button>
        <app-button
            [disabled]="form.invalid || mergeAccountStatus !== 'idle'"
            [loading]="(loading$ | async) || mergeAccountStatus === 'processing'"
            [text]="(stepper.selectedIndex === 0 ? 'buttons.next' : 'buttons.merge') | translate"
            [type]="buttonTypes.cta"
            (click)="nextStep()"
        ></app-button>
    </mat-dialog-actions>
</div>
